export default __webpack_public_path__ + "static/media/aa9929b5afdfac72.530a4d4b8b800dfb82dec21071fec220.svg";